<template>
    <div class="welcome-landing-root grade-11-page min-h-screen bg-background">
        <welcome-navbar />
        <grade-11-landing
            :courses-route="coursesRoute"
            :whatsapp-url="whatsappUrl"
        />
        <welcome-footer />
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed';
import WelcomeNavbar from '@/components/welcome/landing/WelcomeNavbar.vue';
import WelcomeFooter from '@/components/welcome/landing/WelcomeFooter.vue';
import Grade11Landing from '@/components/welcome/landing/grade11/Grade11Landing.vue';
import { gradeCoursesRoute, GRADE_PAGE_SLUGS } from '@/components/welcome/landing/landing-grade-data';

const GRADE_11_WHATSAPP_PHONE = '201234511022';
const GRADE_11_WHATSAPP_MESSAGE = 'السلام عليكم، أنا عايز أحجز كورس تانية ثانوي في البرمجة مع غنيم.';

export default {
    name: 'Grade11',
    components: {
        WelcomeNavbar,
        WelcomeFooter,
        Grade11Landing,
    },
    computed: {
        ...GlobalComputed,
        coursesRoute() {
            return gradeCoursesRoute(this.appData, GRADE_PAGE_SLUGS.GRADE_11);
        },
        whatsappUrl() {
            return `https://wa.me/${GRADE_11_WHATSAPP_PHONE}?text=${encodeURIComponent(GRADE_11_WHATSAPP_MESSAGE)}`;
        },
    },
};
</script>

<style src="@/scss/welcome-landing.css"></style>
<style src="@/scss/grade-11-landing.css"></style>
